import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class WeightStationsApi extends ApiModule {
	constructor() {
		super(ModulesMap.WEIGHT_STATIONS, {
			entity: 'stations',
			entityGroup: 'weighing',
		})
	}
}
